import { Component, Inject, Vue } from 'vue-property-decorator';
import SalesDeliveriesCarouselSheet from '@/core/spe/dashboard/sheets/sales-deliveries-carousel-sheet.vue';
import SalesInvoicesDashboard from '@/core/spe/dashboard/dashboards/sales-invoices-dashboard.vue';
import SalesOrdersDashboard from '@/core/spe/dashboard/dashboards/sales-orders-dashboard.vue';
import SalesQuotesCarouselSheet from '@/core/spe/dashboard/sheets/sales-quotes-carousel-sheet.vue';
import { AccountService } from '@gv/ammo-grome';

@Component({
  components: {
    SalesDeliveriesCarouselSheet,
    SalesInvoicesDashboard,
    SalesOrdersDashboard,
    SalesQuotesCarouselSheet,
  },
})
export default class PortletsCarouselApp extends Vue {
  @Inject('accountService')
  private accountService: () => AccountService;
  private hasAnyAuthorityValues = {};
  /** Tracks the current item displayed in Carousel */
  public activeCarouselItemIndex = 0;
  public slides: string[] = ['SalesInvoicesDashboard', 'SalesOrdersDashboard'];

  public get authenticated(): boolean {
    return this.$store.getters.authenticated;
  }

  public itemChange(payload) {}

  public hasAnyAuthority(authorities: any): boolean {
    this.accountService()
      .hasAnyAuthorityAndCheckAuth(authorities)
      .then(value => {
        if (this.hasAnyAuthorityValues[authorities] !== value) {
          this.hasAnyAuthorityValues = { ...this.hasAnyAuthorityValues, [authorities]: value };
        }
      });
    return this.hasAnyAuthorityValues[authorities] ?? false;
  }
}
